import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import http from './plugins/axios'
import userInfoHelper from 'common/userInfo'
import cookies from 'js-cookie'

Vue.use(Vuex)

//eslint-disable-next-line
const debug = process.env.NODE_ENV !== 'production'
const systemId = Math.floor(Math.random() * 100 + 1)
const state = {
  userInfo: userInfoHelper.get(),
  isCustom: false,
}

const mutations = {
  setUserInfo(state, payload) {
    console.log('payload', payload)
    state.userInfo = payload
    state.isCustom = payload.roles.some(
      (item) => item.productId == 5 && item.name === '客服'
    )
    userInfoHelper.set(payload)
  },
}

const actions = {
  // login({ commit }, { account, password, code ,gCode}) {
  //   return http
  //     .post({
  //       url: '/la/admin/login',
  //       data: {
  //         account,
  //         password,
  //         phoneCode: code,
  //         gCode
  //       }
  //     })
  //     .then(({ data }) => {
  //       let _data = Object.assign({}, data);
  //       if (_data.roleId === 10) {
  //         _data.roleId = 0;
  //         _data.isSupper = true;
  //       }
  //       if (_data.roleId === 11) {
  //         _data.roleId = 0;
  //         _data.isSupper = true;
  //         _data.roleType = data.roleId;
  //       }
  //       commit('setUserInfo', _data);
  //     });
  // },
  init({ commit }) {
    return http
      .get({
        url: '/la/admin/init',
      })
      .then(({ data }) => {
        return data
      })
  },

  login({ commit }, { account, password, geetest }) {
    return http
      .post({
        url: '/la/admin/login',
        data: {
          account,
          password,
          geetest,
        },
      })
      .then((res) => {
        // console.log('userInfo',res);
        return res
        // let _data = Object.assign({}, data);
        // if (_data.roleId === 10) {
        //   _data.roleId = 0;
        //   _data.isSupper = true;
        // }
        // if (_data.roleId === 11) {
        //   _data.roleId = 0;
        //   _data.isSupper = true;
        //   _data.roleType = data.roleId;
        // }
        // commit('setUserInfo', _data);
      })
  },
  secondSuffix({ commit }, { account, password, verifyCode, judgeToken }) {
    return http
      .post({
        url: '/la/admin/token/suffix',
        data: {
          account,
          password,
          verifyCode,
          judgeToken,
        },
        headers: {
          systemId: systemId,
        },
      })
      .then((res) => {
        // console.log('suffix',res);
        if (res.code == 0) {
          userInfoHelper.setUser(res.data.token)
        }
        return res
      })
  },
  logout() {
    return http
      .post({
        url: '/la/admin/logout',
      })
      .then(() => {
        userInfoHelper.clear()
        window.location.href = '/'
      })
  },
  // logout() {
  //   return http
  //     .post({
  //       url: '/la/admin/logout'
  //     })
  //     .then(() => {
  //       userInfoHelper.clear();
  //       window.location.href = '/';
  //     });
  // },
  //eslint-disable-next-line
  getPhoneCode({ commit }, loginName) {
    return new Promise((resolve) => {
      http
        .get({
          url: '/la/admin/check/code',
          data: {
            loginName,
          },
        })
        .then(({ data }) => {
          resolve(data)
        })
    })
  },
  getUserInfo({ commit }) {
    return http
      .get({
        url: '/la/admin/info',
      })
      .then((res) => {
        // console.log('info-res',res);
        if (res.code == 0) {
          userInfoHelper.set(res.data.data)
          commit('setUserInfo', res.data.data)
        }
        return res
      })
  },
  getOtcList({ commit }, { userId, page, size }) {
    return http
      .get({
        url: `/otc-admin/admin/otc/getOtcUserList?userId=${userId}&page=${page}&size=${size}`,
      })
      .then((res) => {
        // console.log('info-res',res);
        // if(res.code==0){
        //   commit('setOtcList', res.data.data);
        // }
        return res
      })
  },
}

export default new Vuex.Store({
  strict: debug,
  plugins: debug ? [createLogger()] : [],
  state,
  mutations,
  actions,
})
